goog.provide("shadow.js.shim.module$src$svg$wpp$arrows$trend_ascent_svg$default");
shadow.js.shim.module$src$svg$wpp$arrows$trend_ascent_svg$default = shadow.js.shim.module$src$svg$wpp$arrows$trend_ascent_svg.default;
